<template>
    <flex-container justify-content="space-between">
        <flex-container
            size="auto"
            :gap="Size.xs"
            direction="column"
        >
            <text-heading>
                <span v-if="template.name.length > 0">{{ template.name }}</span>
                <span v-else>Nieuwe template</span>
            </text-heading>

            <text-description />
        </flex-container>

        <flex-container
            size="auto"
            justify-content="flex-end"
            align-items="center"
        >
            <button-outline @click="backToLister">
                Annuleren
            </button-outline>

            <button-block @loading="saveTemplate">
                Template opslaan
            </button-block>
        </flex-container>
    </flex-container>

    <horizontal-line />

    <flex-container>
        <flex-container :size="10">
            <card-normal>
                <flex-container align-items="flex-end" :gap="Size.xl">
                    <flex-container :size="5">
                        <input-group v-model="template.name">
                            <template #label>
                                <input-label>
                                    Naam template
                                </input-label>
                            </template>
                            <template #input>
                                <text-input placeholder="Woningbrochure 1" />
                            </template>
                        </input-group>
                    </flex-container>

                    <flex-container :size="5">
                        <input-group v-model="template.active">
                            <template #input>
                                <flex-container :gap="Size.sm" align-items="center">
                                    <switch-input variant="small" />
                                    <span>Actief</span>
                                </flex-container>
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>

                <horizontal-line />

                <flex-container :gap="Size.xl">
                    <flex-container :size="5">
                        <flex-container :size="5">
                            <img
                                v-if="uploadedFilePreview"
                                class="logo_preview"
                                :src="uploadedFilePreview"
                                alt=""
                            />
                            <img
                                v-else-if="template.logo && template.logo.url"
                                class="logo_preview"
                                :src="template.logo.url"
                                alt=""
                            />
                        </flex-container>

                        <flex-container
                            :size="5"
                            align-content="center"
                            justify-content="flex-end"
                        >
                            <button-block @loading="uploadLogoModal?.openOverlay(); $event.button.setState(ButtonState.completed)">
                                <span v-if="template.logo || uploadedFilePreview">Veranderen</span>
                                <span v-else>Logo uploaden</span>
                            </button-block>

                            <button-outline
                                v-if="template.logo || uploadedFilePreview"
                                :color="Color.red500"
                                @click="removeLogo"
                            >
                                Verwijderen
                            </button-outline>
                        </flex-container>
                    </flex-container>
                    <flex-container :size="5" align-content="end">
                        <input-group v-model="template.nvmLogoVisible">
                            <template #input>
                                <flex-container :gap="Size.sm" align-items="center">
                                    <switch-input variant="small" />

                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 35 50"
                                        height="20"
                                        fill="#015ad2"
                                    >
                                        <path d="M9.705 38.242v11.505h-.77l-6.54-6.984v6.779H.084V38.037h.753l6.557 6.951v-6.746h2.311m12.363 0-5.033 11.505h-.771l-5.05-11.505h2.62l2.824 6.849 2.808-6.849h2.602m12.585-.205v11.505h-2.311v-6.027l-2.843 3.562h-.753l-2.842-3.562v6.027h-2.311V38.037h.753l4.777 6.112 4.777-6.112h.753M32.106.097c1.394 0 2.524 1.112 2.524 2.484v30.707a1.39 1.39 0 0 1-1.4 1.377h-7.692c-.774 0-1.4-.616-1.4-1.377V22.743c0-1.566 1.289-2.835 2.88-2.835h.287c2.603 0 4.714-2.077 4.714-4.64 0-2.563-2.111-4.64-4.714-4.64s-4.713 2.077-4.713 4.64l.017 18.02a1.39 1.39 0 0 1-1.4 1.377h-7.681c-.773 0-1.4-.616-1.4-1.377l.017-18.02c0-2.563-2.11-4.64-4.714-4.64-2.603 0-4.713 2.077-4.713 4.64 0 2.563 2.11 4.64 4.713 4.64h.288c1.59 0 2.88 1.27 2.88 2.835v10.545c0 .76-.626 1.377-1.4 1.377H1.506a1.39 1.39 0 0 1-1.4-1.377V2.58C.106 1.209 1.236.097 2.63.097l10.376.012c2.03 0 3.677 1.621 3.677 3.619l-.187.06c-2.146.403-3.768 2.262-3.768 4.492 0 2.526 2.08 4.574 4.647 4.574h-.012c2.566 0 4.645-2.048 4.645-4.574 0-2.23-1.622-4.089-3.768-4.492l-.187-.06C18.053 1.73 19.7.109 21.73.109L32.106.097" />
                                    </svg>

                                    <span v-if="template.nvmLogoVisible">Zichtbaar</span>
                                    <span v-else>Verborgen</span>
                                </flex-container>
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>

                <horizontal-line />

                <flex-container style="margin-bottom: 20px">
                    <flex-container :size="5">
                        <color-input v-model="template.primaryColor">
                            Primaire kleur
                        </color-input>
                    </flex-container>
                    <flex-container :size="5">
                        <color-input v-model="template.primaryTextColor">
                            Primaire tekst kleur
                        </color-input>
                    </flex-container>
                </flex-container>

                <flex-container>
                    <flex-container :size="5">
                        <color-input v-model="template.secondaryColor">
                            Secundaire kleur
                        </color-input>
                    </flex-container>
                    <flex-container :size="5">
                        <color-input v-model="template.secondaryTextColor">
                            Secundaire tekst kleur
                        </color-input>
                    </flex-container>
                </flex-container>

                <horizontal-line />

                <flex-container no-wrap>
                    <input-group v-model:model-value="template.photosVisible">
                        <template #input>
                            <flex-container :gap="Size.sm" align-items="center">
                                <switch-input variant="small" />
                                <span>Woningfoto's toevoegen als bijlage</span>
                            </flex-container>
                        </template>
                    </input-group>

                    <input-group v-model:model-value="template.mapsVisible">
                        <template #input>
                            <flex-container :gap="Size.sm" align-items="center">
                                <switch-input variant="small" />
                                <span>Plattegrond toevoegen</span>
                            </flex-container>
                        </template>
                    </input-group>
                </flex-container>

                <template #sections>
                    <card-section area="card-footer" style="flex-direction: column; gap: 20px;">
                        <flex-container no-wrap align-items="flex-end">
                            <flex-container>
                                <input-group v-model="search">
                                    <template #label>
                                        <input-label>
                                            Woning zoeken
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <text-input>
                                            <template #prefix>
                                                <svg-icon :icon="IconSearch" :size="IconSize.sm" />
                                            </template>
                                        </text-input>
                                    </template>
                                </input-group>
                            </flex-container>
                        </flex-container>

                        <div v-if="filteredSearchResults.length > 0">
                            <text-heading sub>
                                {{ filteredSearchResults.length }} resultaten gevonden voor '{{ search }}'
                            </text-heading>

                            <two-columns class="search-results">
                                <template
                                    v-for="result in filteredSearchResults"
                                    :key="result.id"
                                >
                                    <div>{{ result.adres.straat }} {{ result.adres.huisnummer }}{{ result.adres.huisnummertoevoeging }}, {{ result.adres.postcode }} {{ result.adres.plaats }}</div>
                                    <button-block @loading="(event) => updatePreview(event, result)">
                                        <svg-icon :icon="IconRefresh" />
                                        <span>Voorbeeld</span>
                                    </button-block>
                                </template>
                            </two-columns>
                        </div>
                    </card-section>
                </template>
            </card-normal>
        </flex-container>
        <flex-container :size="10" style="flex: 0 0 640px;">
            <card-normal>
                <input-group v-model="templateModel">
                    <template #label>
                        <input-label>
                            Template keuze
                        </input-label>
                    </template>
                    <template #input>
                        <select-input
                            :items="availableTemplates"
                            value-key-name="value"
                            label-key-name="label"
                        />
                    </template>
                </input-group>
            </card-normal>

            <card-normal>
                <iframe
                    ref="previewIframe"
                    title="Preview"
                    :srcdoc="formattedPreview"
                    style="width: 100%; height: 896px; border: none;"
                />
            </card-normal>
        </flex-container>
    </flex-container>

    <modal-dialog
        ref="uploadLogoModal"
        label="Nieuw logo uploaden"
        description="Nieuw logo uploaden"
        :size="4"
    >
        <flex-container :gap="Size.xs" direction="column">
            <text-heading>Logo uploaden</text-heading>
            <text-description>
                Kies een logo (png, jpg, svg, etc)
            </text-description>
        </flex-container>

        <horizontal-line />

        <input-group v-if="!uploadedFilePreview" v-model="uploadedFiles">
            <template #input>
                <file-drop-zone-input />
            </template>
        </input-group>

        <flex-container v-else justify-content="center">
            <img
                :src="uploadedFilePreview"
                style="max-width: 100%; max-height: 100%; padding: 2rem"
                alt=""
            />
        </flex-container>

        <template #footer>
            <dialog-footer v-if="uploadedFilePreview">
                <flex-container align-items="center" justify-content="flex-end">
                    <button-text :color="Color.red500" @click="deleteUploadedLogo">
                        Verwijderen
                    </button-text>

                    <button-block @loading="submitLogoUpload($event)">
                        Bevestigen
                    </button-block>
                </flex-container>
            </dialog-footer>
        </template>
    </modal-dialog>
</template>

<script setup lang="ts">
    import { Template, User, CreateTemplateCommand, ChangeTemplateCommand, PreviewTemplateCommand, LogoId, Logo, CreateLogoCommand } from '@keyvue/one-api-client';
    import { ButtonState, type ButtonStateChangedEvent, Color, type ExposedOverlay, IconSize, Size } from '@keyvue/one-ui';
    import { RealworksAPI } from '@keyvue/one-api-client-legacy';

    import { computed, reactive, ref, watch } from 'vue';
    import { useRouter } from 'vue-router';
    import useClient from '@composables/useClient';
    import useNotify from '@composables/useNotify';

    import TwoColumns from '@components/UI/TwoColumns.vue';
    import IconSearch from '@keyvue/one-material-icons/icons/search.svg?component';
    import IconRefresh from '@keyvue/one-material-icons/icons/refresh.svg?component';
    import ColorInput from '@components/Inputs/ColorInput.vue';

    interface Props {
        templateId?: string;
    }

    const props = defineProps<Props>();
    const createNew = props.templateId === undefined;
    const router = useRouter();
    const { client, currentUser, currentCompany } = useClient();
    const { notifySaving, notifySaved, notifyError } = useNotify();

    const template = reactive(createNew
        ? Template.create({ ...currentUser.value, company: currentCompany?.value ?? null } as User)
        : await client.get(Template, props.templateId)) as Template;

    const availableTemplates = computed(() => [
        { value: '667c0e84-d459-4f01-94e3-f11c238c881e', label: 'Brochure - Liggend', orientation: 'landscape' },
        { value: 'f9b655c1-1363-4664-b5a9-4d3d86901ef9', label: 'Brochure - Staand', orientation: 'portrait' },
    ]);

    const search = ref('');
    const searchResults = ref<any[]>([]);
    const filteredSearchResults = computed(() => searchResults.value.slice(0, 10));

    watch(search, async (value) => {
        if (value.length < 3) {
            searchResults.value = [];
            return;
        }

        if (!currentCompany.value?.id.value) {
            return;
        }

        searchResults.value = await RealworksAPI.searchWonenObjects(
            currentCompany.value?.id.value,
            search.value,
        );
    });

    const backToLister = () => {
        router.push({ name: 'documentTemplateList' });
    };

    const saveTemplate = async (event: ButtonStateChangedEvent) => {
        try {
            notifySaving();

            if (uploadedFile.value) {
                const id = LogoId.generate();
                const logo = Logo.fromObject({
                    id,
                });

                await client.dispatch(
                    new CreateLogoCommand(
                        currentCompany.value?.id.value ?? '',
                        id.value,
                        uploadedFile.value,
                    ),
                );

                template.logo = logo;
            }

            await client.dispatch(
                createNew
                    ? CreateTemplateCommand.fromTemplate(template)
                    : ChangeTemplateCommand.fromTemplate(template),
            );
            notifySaved();
            backToLister();
        } catch (error) {
            notifyError(error);
        } finally {
            event.button.setState(ButtonState.completed);
        }
    };

    const orientation = computed(() => templateModel.value?.orientation);
    const previewIframe = ref<HTMLIFrameElement>();

    const previewZoom = ref(1.0);
    const recalculatePreviewZoom = () => {
        let pageWidth = 793;
        if (orientation.value === 'landscape') {
            pageWidth = 1120;
        }

        // clientWidth - left margin - right margin - scrollbar width
        const iframeWidth = (previewIframe.value?.clientWidth ?? pageWidth) - 16 - 16 - 24;

        previewZoom.value = Math.min(1, iframeWidth / pageWidth);
    };

    const preview = ref('');
    const updatePreview = async (event: ButtonStateChangedEvent, result: any) => {
        preview.value = '';
        recalculatePreviewZoom();

        try {
            preview.value = await client.dispatch(
                PreviewTemplateCommand.fromTemplate({
                    template,
                    wonenObjectId: result.id,
                }),
            );
        } catch (error) {
            notifyError(error);
        } finally {
            event.button.setState(ButtonState.completed);
        }
    };

    const templateModel = computed({
        get: () => availableTemplates.value.find((availableTemplate) => availableTemplate.value === template.template),
        set: (value) => {
            template.template = value?.value ?? template.template;
        },
    });

    const formattedPreview = computed(() => `
        ${preview.value}

        <style>
            html {
                -moz-transform: scale(${previewZoom.value});
                -moz-transform-origin: 0 0;
                -o-transform: scale(${previewZoom.value});
                -o-transform-origin: 0 0;
                -webkit-transform: scale(${previewZoom.value});
                -webkit-transform-origin: 0 0;
            }
        </style>
    `);

    const uploadLogoModal = ref<ExposedOverlay>();
    const uploadedFiles = ref<File[]>([]);

    const deleteUploadedLogo = () => {
        uploadedFiles.value = [];
        uploadLogoModal.value?.closeOverlay();
    };

    const submitLogoUpload = async (event: ButtonStateChangedEvent) => {
        if (!currentCompany.value) {
            return;
        }

        try {
            await client.dispatch(
                new CreateLogoCommand(
                    currentCompany.value?.id.value,
                    LogoId.generate().value,
                    uploadedFile.value,
                ),
            );

            uploadLogoModal.value?.closeOverlay();
        } catch (error) {
            notifyError(error);
        } finally {
            event.button.setState(ButtonState.completed);
        }
    };

    const uploadedFile = computed(() => {
        if (!uploadedFiles.value) {
            return undefined;
        }

        return uploadedFiles.value[0];
    });

    const uploadedFilePreview = computed(() => {
        if (!uploadedFile.value) {
            return false;
        }

        return URL.createObjectURL(uploadedFile.value);
    });

    const removeLogo = () => {
        // @todo: delete command? -- besproken met Michel; dit is ok voor nu
        uploadedFiles.value = [];
        template.logo = null;
    };
</script>

<style scoped lang="scss">
.search-results {
    margin-top: size(md);
    padding: size(md);
    grid-template-columns: auto min-content;
    align-items: center;
    background-color: white;
}

.logo_preview {
    max-height: 96px;
    max-width: 100%;
    padding: 2rem;
}
</style>
